import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { ComponentSecurityService } from "../../Services/component-security.service";
import { ComponentSecurity } from "../../Model/component-security";
import { NgxSmartModalService } from "ngx-smart-modal";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder
} from "@angular/forms";
import { ComponentSecurityValidators } from "./component-security-validators";
import { ToastrService } from "ngx-toastr";
import Swal from "sweetalert2";

@Component({
  selector: "component-security-revisions",
  templateUrl: "./component-security-revisions.component.html",
  styleUrls: ["./component-security-revisions.component.css"]
})
export class ComponentSecurityRevisionsComponent implements OnInit {
  public componentSecurity: ComponentSecurity[];
  public columnDefs = [];
  public rowData = [];
  private gridApi;
  private gridColumnApi;
  private gridOptions;
  private defaultColDef;
  private rowSelection;
  private crudAction;
  public form: FormGroup;
  public canUpdateForm: boolean;
  public clicked: boolean = false;

  constructor(
    private service: ComponentSecurityService,
    public ngxSmartModalService: NgxSmartModalService,
    private componentSecurityValidators: ComponentSecurityValidators,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private securityService: ComponentSecurityService
  ) {
    this.defaultColDef = { sortable: true, filter: true };
    this.rowSelection = "single";
    this.createFormGroup();
    this.createGridColumnDefs();
  }

  @ViewChild("componentName", { static: true }) componentNameField: ElementRef;

  ngOnInit() {
    this.service.getAll().subscribe(
      response => {
        if (response.length > 0) {
          this.rowData = response;
        } else {
          this.rowData = null;
          this.toastr.warning("No records found", "Warning");
        }
      },
      error => {
        this.toastr.error("Unable to access database", "Error");
      }
    );

    // Get form security
    this.securityService
      .canUpdate(this.constructor.name, localStorage.getItem("user"))
      .subscribe(
        response => {
          if (response.length > 0) this.canUpdateForm = true;
          else {
            this.canUpdateForm = false;
          }
        },
        error => {
          this.canUpdateForm = false;
        }
      );
  }

  createFormGroup() {
    this.form = this.fb.group(
      {
        componentName: new FormControl(null, [Validators.required]),
        user: new FormControl(null, [Validators.required]),
        changeID: new FormControl(""),
        lastUpdated: new FormControl(""),
        id: new FormControl("")
      },
      {
        validator: this.componentSecurityValidators.shouldBeUnique.bind(this)
      }
    );
  }

  createGridColumnDefs() {
    this.columnDefs = [
      { headerName: "ID", field: "id", hide: true },
      { headerName: "changeID", field: "changeID", hide: true },
      { headerName: "lastUpdated", field: "lastUpdated", hide: true },
      {
        headerName: "Component Name",
        field: "componentName",
        filter: "agTextColumnFilter"
      },
      {
        headerName: "User",
        field: "user",
        type: "string",
        filter: "agTextColumnFilter"
      }
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
    setTimeout(() => this.componentNameField.nativeElement.focus());
  }

  onSelectionChanged(event) {
    // only open the window of row selected
    if (event.node.selected) {
      this.ngxSmartModalService.setModalData(
        this.gridApi.getSelectedRows()[0],
        "myModal",
        true
      );
      this.crudAction = "Update";
      this.loadInitialFormValues();
      this.ngxSmartModalService.getModal("myModal").open();
      setTimeout(() => this.componentNameField.nativeElement.focus());
    }

    // capture the event, so deselectall can be call when window closed
    this.gridOptions = event;
  }

  export() {
    let params = {
      fileName: "ComponentSecurity",
      allColumns: true
    };
    this.gridApi.exportDataAsExcel(params);
  }

  loadInitialFormValues() {
    this.form.patchValue({
      componentName: this.gridApi.getSelectedRows()[0]["componentName"],
      user: this.gridApi.getSelectedRows()[0]["user"],
      changeID: this.gridApi.getSelectedRows()[0]["changeID"],
      lastUpdated: this.gridApi.getSelectedRows()[0]["lastUpdated"],
      id: this.gridApi.getSelectedRows()[0]["id"]
    });
    this.clicked = false;
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  get componentAlreadyTaken() {
    return (
      this.form.get("componentName").hasError("existsTerms") &&
      this.form.get("componentName").touched
    );
  }

  modalAction() {
    switch (this.crudAction) {
      case "Update":
        this.service
          .update(
            this.form.value,
            this.ngxSmartModalService.getModalData("myModal").id
          )
          .subscribe(
            response => {
              if (response["success"] == "true")
                this.toastr.success("Record updated", "Success");
              this.service.getAll().subscribe(data => {
                this.rowData = data;
                this.gridApi.setRowData(this.rowData);
              });
            },
            error => {
              this.toastr.error("Record not updated", "Error");
            }
          );
        this.ngxSmartModalService.get("myModal").close();

        break;
      case "Create":
        this.service.create(this.form.value).subscribe(
          response => {
            if (response["success"] == "true")
              this.toastr.success("New record added", "Success");
            this.service.getAll().subscribe(data => {
              this.rowData = data;
              this.gridApi.setRowData(this.rowData);
            });
          },
          error => {
            this.toastr.error("Record not added", "Error");
          }
        );
        this.ngxSmartModalService.get("myModal").close();

        break;
      case "Delete":
        this.service
          .delete(this.ngxSmartModalService.getModalData("myModal").id)
          .subscribe(
            response => {
              this.toastr.success("Record deleted", "Success");
              this.service.getAll().subscribe(data => {
                this.rowData = data;
                this.gridApi.setRowData(this.rowData);
              });
            },
            error => {
              this.toastr.error("Record not deleted", "Error");
            }
          );
        this.ngxSmartModalService.get("myModal").close();

        break;
    }
  }

  close() {
    if (typeof this.gridOptions != "undefined")
      this.gridOptions.api.deselectAll();
  }

  create() {
    this.crudAction = "Create";
    this.ngxSmartModalService.resetModalData("myModal");
    this.form.reset();
    this.clicked=false;
    this.ngxSmartModalService.getModal("myModal").open();
    setTimeout(() => this.componentNameField.nativeElement.focus());
  }

  // delete() {
    // this.crudAction = "Delete";
    // if (window.confirm("Are sure you want to delete this item ?")) {
      // this.modalAction();
    // } else {
      // this.ngxSmartModalService.get("myModal").close();
    // }
  // }

  delete() {
    this.crudAction = "Delete";
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    }).then(result => {
      if (result.value) {
        this.modalAction();
      }
    });
  }
}
